import { DefaultButton, Dialog, DialogFooter, DialogType, IDialogContentProps, PrimaryButton, TextField } from "@fluentui/react";
import React from "react";
import { LanguageContext } from "../../utilities/LocalizationModule";
import { useSelector } from "react-redux";
import { RootState } from "../../src/taskpane/components/_v2/redux/storeMain";

export interface ICMEntireFolderChooseNameDialogProps {
  showDialog: boolean;
  closeDialog: () => void;
  closeOnSelection: (folderName: string) => void;
}

export const CMEntireFolderChooseNameDialog = ({ showDialog, closeDialog, closeOnSelection }: ICMEntireFolderChooseNameDialogProps) => {
  const languageStrings = React.useContext(LanguageContext);

  const exchangeFolderName = useSelector((state: RootState) => state.contentManagerDirectory?.exchange?.selectedFolderName);

  const [folderName, setFolderName] = React.useState<string>("");
  const [errorMessage, setErrorMessage] = React.useState("");

  React.useEffect(() => {
    setFolderName(exchangeFolderName);
  }, [exchangeFolderName]);

  const dialogContentProps: IDialogContentProps = {
    type: DialogType.normal,
    title: languageStrings.FolderName,
    showCloseButton: true,
    closeButtonAriaLabel: 'Close',
    subText: languageStrings.DoYouWantToCreateFolder
  };

  const onChange = React.useCallback(async (event?: React.ChangeEvent<HTMLInputElement>, newValue?: string) => {
    setErrorMessage("");
    setFolderName(newValue);
  }, []);

  return (
    <Dialog hidden={!showDialog} onDismiss={closeDialog} dialogContentProps={dialogContentProps}>
      <TextField
        required
        value={folderName}
        onChange={onChange}
        errorMessage={errorMessage}
      />
      <DialogFooter>
        <PrimaryButton text={languageStrings.Yes} onClick={() => {
          if (!folderName) {
            setErrorMessage(languageStrings.EnterFolderName);
          } else {
            closeOnSelection(folderName?.trim());
          }
        }} />
        <DefaultButton onClick={() => closeOnSelection("")} text={languageStrings.No} /></DialogFooter>
    </Dialog>
  )
};